<section class="transaction-create-page">
  <app-admin-page-header
    title="Criar transação"
    subtitle="Registe uma transação administrativa para um utilizador (unidade, quantidade, tipo e status).">
    <div header-actions class="detail-header-actions">
      <button type="button" class="admin-btn admin-btn--secondary" (click)="goBack()">Voltar</button>
    </div>
  </app-admin-page-header>

  <div *ngIf="isLoadingUsers && !initialUsersLoaded" class="detail-feedback">
    <p-progressSpinner strokeWidth="6" ariaLabel="Carregando" styleClass="transaction-create-spinner"></p-progressSpinner>
    <span>A carregar utilizadores…</span>
  </div>

  <p *ngIf="formSuccess" class="detail-feedback detail-feedback--success">{{ formSuccess }}</p>
  <p *ngIf="formError" class="detail-feedback detail-feedback--error">{{ formError }}</p>

  <div class="detail-sections">
    <section class="detail-section admin-surface">
      <div class="detail-section__header">
        <h3>Dados da transação</h3>
      </div>

      <article class="detail-card detail-card--nested">
        <h4>Formulário</h4>
        <form [formGroup]="transactionForm" class="transaction-create-form" (ngSubmit)="confirmTransaction()">
          <div class="transaction-create__fields">
            <div class="transaction-create__field">
              <label for="tc-user" class="transaction-create__label">Utilizador</label>
              <div class="transaction-create__field-control">
                <p-autoComplete
                  inputId="tc-user"
                  formControlName="user"
                  [suggestions]="filteredUsers"
                  (completeMethod)="searchUsers($event)"
                  (onFocus)="onUserFieldFocus()"
                  [dropdown]="true"
                  [fluid]="true"
                  [forceSelection]="true"
                  field="email"
                  dataKey="id"
                  placeholder="Pesquisar por e-mail"
                  [showEmptyMessage]="true"
                  emptyMessage="Nenhum utilizador encontrado"
                  [minLength]="0"
                  panelStyleClass="transaction-create-autocomplete-panel"
                  inputStyleClass="admin-input">
                  <ng-template let-user pTemplate="item">
                    <span>{{ user.email }}</span>
                  </ng-template>
                </p-autoComplete>
              </div>
              <span
                class="transaction-create__hint transaction-create__hint--error"
                *ngIf="transactionForm.get('user')?.invalid && transactionForm.get('user')?.touched">
                Selecione um utilizador.
              </span>
            </div>

            <div class="transaction-create__field">
              <label for="tc-unit" class="transaction-create__label">Unidade</label>
              <div class="transaction-create__field-control">
                <select id="tc-unit" class="admin-input" formControlName="unit">
                  <option value="">Selecione</option>
                  <option *ngFor="let o of unitOptions" [value]="o.value">{{ o.label }}</option>
                </select>
              </div>
              <span
                class="transaction-create__hint transaction-create__hint--error"
                *ngIf="transactionForm.get('unit')?.invalid && transactionForm.get('unit')?.touched">
                Obrigatório.
              </span>
            </div>

            <div class="transaction-create__field">
              <label for="tc-quantity" class="transaction-create__label">Quantidade</label>
              <div class="transaction-create__field-control">
                <input
                  id="tc-quantity"
                  type="number"
                  class="admin-input"
                  formControlName="quantity"
                  step="1"
                  placeholder="Ex.: 100 ou -100" />
              </div>
              <span
                class="transaction-create__hint transaction-create__hint--error"
                *ngIf="transactionForm.get('quantity')?.invalid && transactionForm.get('quantity')?.touched">
                Informe um número inteiro diferente de zero.
              </span>
            </div>

            <div class="transaction-create__field">
              <label for="tc-type" class="transaction-create__label">Tipo de transação</label>
              <div class="transaction-create__field-control">
                <select id="tc-type" class="admin-input" formControlName="transactionType">
                  <option value="">Selecione</option>
                  <option *ngFor="let o of transactionTypeOptions" [value]="o.value">{{ o.label }}</option>
                </select>
              </div>
              <span
                class="transaction-create__hint transaction-create__hint--error"
                *ngIf="transactionForm.get('transactionType')?.invalid && transactionForm.get('transactionType')?.touched">
                Obrigatório.
              </span>
            </div>

            <div class="transaction-create__field">
              <label for="tc-status" class="transaction-create__label">Status</label>
              <div class="transaction-create__field-control">
                <select id="tc-status" class="admin-input" formControlName="status">
                  <option value="">Selecione</option>
                  <option *ngFor="let o of transactionStatusOptions" [value]="o.value">{{ o.label }}</option>
                </select>
              </div>
              <span
                class="transaction-create__hint transaction-create__hint--error"
                *ngIf="transactionForm.get('status')?.invalid && transactionForm.get('status')?.touched">
                Obrigatório.
              </span>
            </div>
          </div>

          <div class="detail-card__actions transaction-create__actions">
            <button
              type="submit"
              class="admin-btn admin-btn--primary"
              [disabled]="transactionForm.invalid || isSubmitting || isLoadingUsers">
              {{ isSubmitting ? 'A criar…' : 'Criar transação' }}
            </button>
            <button type="button" class="admin-btn admin-btn--secondary" (click)="clearForm()" [disabled]="isSubmitting">
              Limpar
            </button>
          </div>
        </form>
      </article>
    </section>
  </div>
</section>
